import React, { useId } from 'react';

export function BogoIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  const clipId = useId();
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <rect x='6' y='6' width='13' height='13' rx='1' stroke='currentColor' strokeWidth='2' />
        <rect x='6' y='6' width='13' height='13' rx='1' stroke='currentColor' strokeOpacity='0.2' strokeWidth='2' />
        <path
          d='M14 3V2C14 1.44772 13.5523 1 13 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H3'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
        />
        <path
          d='M14 3V2C14 1.44772 13.5523 1 13 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H3'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
